import { Alert, Box, Typography } from '@mui/material';
import { Pricelist } from 'common-models';
import { FC } from 'react';

type PricelistViewProps = {
    pricelist?: Pricelist,
    isFreeOfCharge: boolean,
    displayFreeOfChargeText: boolean,
    hasPhotos: boolean
}

const PricelistView: FC<PricelistViewProps> = ({ pricelist, isFreeOfCharge, displayFreeOfChargeText, hasPhotos }) => {

    if (!hasPhotos) {
        return <></>
    }

    if (isFreeOfCharge) {
        if (displayFreeOfChargeText) {
            return (
                <Alert
                    severity="info"
                    variant="outlined"
                    sx={{
                        mt: 1,
                        mb: 2,
                        backgroundColor: 'rgba(2, 136, 209, 0.04)',
                        '& .MuiAlert-message': {
                            fontSize: '1rem',
                            lineHeight: 1.5
                        }
                    }}
                >
                    <Typography variant="body1" component="div" sx={{ fontWeight: 500, mb: 0.5 }}>
                        Bilderna är fria att ladda ned och använda
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '0.9375rem', opacity: 0.8 }}>
                        Om du vill ge fotocred i sociala medier så får du gärna tagga{' '}
                        <a href="https://www.instagram.com/photosbyfmork" target="_blank" rel="noopener noreferrer">
                            @photosbyfmork
                        </a>{' '}
                        på Instagram eller{' '}
                        <a href="https://www.facebook.com/photosbyfmork/" target="_blank" rel="noopener noreferrer">
                            Fredrik Mörk Photography
                        </a>{' '}
                        på Facebook (men det är helt frivilligt).
                    </Typography>
                </Alert>
            );
        }

        else {
            return <></>
        }
    }

    if (!pricelist) {
        return <Typography variant='body1'>Priser saknas.</Typography>
    }


    return (
        <Box>
            <Typography variant='h5'>Priser (inkl. moms):</Typography>
            {
                pricelist.products.map(product => {
                    return <Box key={product.productId}>
                        {product.names.sv}: {product.prices.map(price => `${price.quantity} för ${price.priceInSekExclVat * 1.25}`).join(', ')}
                    </Box>
                })
            }
        </Box>
    )
}

export { PricelistView };
